import { useGoogleLogin } from '@react-oauth/google';
import { IconArrowLeft, IconAt, IconPhoneFilled } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { getAccessList, getMyAccessList, getOrganizationList } from '../../api/api.global';
import { postApi } from '../../api/call.api';
import { CHAT_DOMAIN, CHAT_DOMAIN_PROFILE } from '../../api/static.data.pnp';
import { urlApi } from '../../api/url.api';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { AUTO_LOGIN_TOKEN, USER_ID } from '../../statics/localStorage';
import { checkDomain } from '../../utils/domainCheck.util';
import { encryptLocalStorage } from '../../utils/localStorage.utils';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';

const Login = () => {
  const navigate = useNavigate();
  const [isOTPView, setIsOTPView] = useState(false);
  const [otp, setOtp] = useState(null);
  const [otpData, setOtpData] = useState(null);
  const [inputValue, setInputValue] = useState(null);
  const [isMobileLogin, setIsMobileLogin] = useState(true);
  const [timerCount, setTimerCount] = useState(60);
  const autoLoginId = AUTO_LOGIN_TOKEN();
  const userId = USER_ID();

  async function autoLogin() {
    if (!autoLoginId || !userId) {
      localStorage.removeItem('advy-token');
      return;
    }
    let postData = {
      userId: userId,
      autoLoginId: autoLoginId,
      signUpDomain: checkDomain()
    }
    loadingShow();
    let resp = await postApi(postData, urlApi.autoLogin);
    loadingHide();
    if (resp.responseCode === 200) {
      await getAccessList();
      encryptLocalStorage('advy-a-l-t', resp?.data?.autoLoginId);
      encryptLocalStorage("profile", resp.data);
      await getOrganizationList();
      if (checkDomain() === "chat") {
        if (resp?.data?.updatedOrganizationDetailsForChat == 1) {
          window.location.replace(CHAT_DOMAIN);
          return;
        } else {
          navigate("/organization-form", { replace: true });
          return;
        }
      }
      if (checkDomain() === "app") {
        navigate('/dashboard', { replace: true });
      }
    } else {
      return
    }
  }

  useEffect(() => {
    if (isOTPView) {
      if (timerCount > 0) {
        var timer = setInterval(() => {
          setTimerCount(prev => prev - 1)
        }, 1000);
      }
    }
    return () => {
      clearInterval(timer);
    };
  }, [timerCount, isOTPView]);

  useEffect(() => {
    autoLogin();
  }, []);

  const getOtp = async (e) => {
    setTimerCount(60);
    e.preventDefault();
    loadingShow();
    if (otp) {
      setOtp(null);
    }
    let postData = {};
    if (isMobileLogin) {
      postData.phone = inputValue
    } else {
      postData.email = inputValue
    }
    let resp = await postApi(postData, urlApi.getOtp);
    loadingHide();
    if (resp.responseCode === 200) {
      setIsOTPView(true)
      toast.success('OTP sent successfully.');
      setOtpData(resp?.data)
    } else {
      setOtpData(resp?.data)
      toast.error(resp?.message);
    }
  }

  const login = async (e) => {
    e.preventDefault();
    loadingShow();
    let postData = {
      otpId: otpData?.otpId,
      otp: otp,
      signUpDomain: checkDomain()
    }
    if (isMobileLogin) {
      postData.phone = inputValue
    } else {
      postData.email = inputValue
    }
    let resp = await postApi(postData, urlApi.verifyOtp);
    loadingHide();
    if (resp.responseCode === 200) {
      await getMyAccessList();
      await getAccessList();
      encryptLocalStorage("profile", resp.data);
      encryptLocalStorage("uid", resp.data?._id);
      encryptLocalStorage('advy-a-l-t', resp?.data?.autoLoginId);
      await getOrganizationList();
      if (checkDomain() === "chat") {
        if (resp?.data?.updatedOrganizationDetailsForChat == 1) {
          if (accessCheck(accessKeys?.createAndUpdateChatSession)) {
            window.location.replace(CHAT_DOMAIN);
          } else {
            window.location.replace(CHAT_DOMAIN_PROFILE)
          }
          return;
        } else {
          navigate("/organization-form", { replace: true });
          return;
        }
      }
      if (checkDomain() === "app") {
        navigate('/dashboard', { replace: true });
      }
    } else {
      toast.error(resp?.message);
    }
  }

  const googleLogin = useGoogleLogin({
    onSuccess: codeResponse => console.log(codeResponse),
    flow: 'auth-code',
  })

  return (
    <div className='mx-auto flex h-screen items-center'>

      <div className='login-form col-span-1 hidden md:flex flex-col gap-2 p-[34px] rounded-3xl w-full'>
        <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" className='w-max h-10 rounded-xl mx-auto mb-24' />
        <img src={process.env.PUBLIC_URL + "/images/login.png"} alt="" className='h-[50vh] aspect-square object-cover' />
        <div className="text-center mb-8">
          <h1 className='text-center font-bold capitalize text-[32px] mt-5'>Link Retargeting</h1>
          <p className='font-normal'>Target ads to users who have previously interacted with your <br /> short URLs to boost conversions</p>
        </div>
      </div>

      <div className='col-span-1 bg-[#EFF4FF] w-full h-full flex flex-col items-center justify-center'>

        <div className='static md:hidden'>
          <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" className='w-max h-10 rounded-xl mx-auto' />
          <div className="text-center mb-12">
            <h1 className='text-center font-bold capitalize text-[20px] mt-3'>Link Retargeting</h1>
            <p className='font-normal text-sm'>Target ads to users who have previously interacted with your <br /> short URLs to boost conversions</p>
          </div>
        </div>

        <div className='text-center px-3'>

          {isOTPView ?

            <div className="flex flex-col items-center justify-center">
              <p className='text-[32px] font-extrabold'>Enter OTP</p>
              <span className=' mb-5'>Sent To {inputValue}</span>
              <form onSubmit={login} className='flex flex-col mb-6'>

                <OTPInput
                  containerStyle={{ gap: '6px' }}
                  inputStyle={{ width: '50px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', height: 50, borderRadius: 20, backgroundColor: 'transparent', border: '2px solid #dddddd', fontWeight: 'bold' }}
                  value={otp}
                  onChange={setOtp}
                  shouldAutoFocus={true}
                  inputType='tel'
                  numInputs={6}
                  renderSeparator={<span>&nbsp;</span>}
                  renderInput={(props) => <input {...props} />}
                />

                <button className='w-full py-2.5 bg-primary rounded-full mt-8 font-semibold text-lg text-white'>Continue</button>

              </form>

              <p className="mb-14 mt-10 text-[0.9rem] text-[#7A829C]">{("Resend OTP in")} <span className={`text-primary ${timerCount == 0 && 'cursor-pointer'}`}
                onClick={(e) => {
                  if (timerCount == 0) { getOtp(e); return; }
                }}>{timerCount > 0 ? `${timerCount}s` : "Resend"}</span></p>

              <div className="mt-5 flex items-center gap-3 cursor-pointer" onClick={() => { setOtp(null); setIsOTPView(false) }}>
                <IconArrowLeft />
                <p className='font-semibold mb-0'>
                  <span>Back To</span>
                  <span className='text-primary'> Login </span>
                </p>
              </div>
            </div>


            :
            <div>
              <p className='text-[32px] font-extrabold mb-5'>Login To Continue</p>
              <form onSubmit={getOtp} className='flex flex-col'>

                <div className='flex items-center px-4 py-2 shadow-lg rounded-full bg-[var(--white)] mb-8'>
                  {isMobileLogin ? <IconPhoneFilled className='cursor-pointer' color='var(--secondary-text)' size={20} /> : <IconAt className='cursor-pointer' color='var(--secondary-text)' size={20} />}
                  {isMobileLogin ? <input type="tel" autoFocus key={"phone"} placeholder="Enter Phone Number" maxLength={10} onChange={(e) => setInputValue(e.target.value)} required id='mobile' className='bg-transparent text-sm p-[10px] focus:outline-none w-full  placeholder-[var(--secondary-text)] min-w-[280px]' /> :
                    <input type="email" autoFocus placeholder="Enter Email ID" onChange={(e) => setInputValue(e.target.value)} required id='email' className='bg-transparent text-sm p-[10px] focus:outline-none w-full  placeholder-[var(--secondary-text)] min-w-[280px]' />}
                </div>

                <button className='w-full py-2.5 bg-primary rounded-full font-semibold text-lg text-white'>Get OTP</button>

              </form>
              <div className="w-full h-[1px] bg-[#E5E9F5] relative my-8">
                <p className="mb-0 absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-[#EFF4FF] px-4">or</p>
              </div>
              {/* <button className='flex items-center gap-3 bg-white w-full justify-center py-3 rounded-[10px] mb-5' onClick={() => window.open('https://dev.fun11.in:9011/google', '_self')}>
                <img src={process.env.PUBLIC_URL + "/images/google.svg"} className='h-6' alt="" /> Continue With Google
              </button> */}
              {isMobileLogin ? <button className='flex items-center gap-3 bg-[var(--black)] w-full justify-center py-3 rounded-[10px] text-white mb-5' onClick={() => setIsMobileLogin(false)}>
                <img src={process.env.PUBLIC_URL + "/images/emailAt.png"} className='h-6' alt="" /> With Email OTP
              </button> :
                <button className='flex items-center gap-3 bg-[var(--black)] w-full justify-center py-3 rounded-[10px] text-white mb-5' onClick={() => setIsMobileLogin(true)}>
                  <img src={process.env.PUBLIC_URL + "/images/phone.svg"} className='h-6' alt="" /> With Phone OTP
                </button>}
              {/* <span>
                <span>Don&apos;t have account?</span>
                <span className='text-primary'> <Link> Sign Up </Link> </span>
              </span> */}
            </div>
          }



        </div>

      </div>

    </div>
  )
}

export default Login